import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import { sbaAxios } from "../../../utils/sbaAxios";
import { Tab, Tabs } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { Modal } from "react-bootstrap";
import { SBNotify } from "../../../utils/sbNotify";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import {
    getWebMenuPermissionsAPI, getGrantedPortalAccessAPI, getDelegatePortalAccessAPI
    , updatetaxEntityAccess, updateInvestorWebAcces, getAvaialbleTaxEntitie, getAvailableInvestors,copyContactWebAccess,
    getWebRoles, getWebRoleDefaultAccess, deletetaxentityAcces, insertTaxEntityWebAccess, insertInvestorWebAccess,insertupdatemenuAcces
} from "../../../../config/apiConfig"
import { SBADrawer } from "../../../UiComponents/SBADrawer";
import { SBADropDown, SBAMultiSelectCheck, SBAComboBox } from "../../../UiComponents/SBADropDown";
import { getActivityEntityType } from "../../../actions/investmentAction";

export const PortalAccess = () => {
    const [menuList, setMenuList] = useState([]);
    const [rowValue, setRowValue] = useState([]);
    const [rowValueflag, setrowValueflag] = useState(false);
    const [detailData, setDetailData] = useState([]);
    const [componentToShow, setComponentToShow] = useState(null);
    const [addAcess, setaddAcess] = useState(false);
    const [copyAcess, setcopyAcess] = useState(false);
    const [activeKey, setActiveKey] = useState('DelegateAnalystData');
    const [rowData, setRowData] = useState([]);
    const [copydata,setCopydata]=useState([]);
    const [portalList, setPortalList] = useState([]);
    const [IsdelegateAccessLoading,setIsdelegatedAccessLoading]=useState(false);
    const [IsgrantedAccessLoading,setIsgrantedAccessLoading]=useState(false);
    const [showAcess, setshowAcess] = useState([]);
    const dispatch = useDispatch();
    const params = useParams();
    const getMenuList = async () => {
        try {
            const response = await sbaAxios({ url: `${getWebMenuPermissionsAPI}${params.ContactId}` });
            const formattedData = [{ ...response }];
                  setRowValue(formattedData);
        } catch (error) {
            console.error("Error fetching menu list:", error);
            return []; // Return an empty array on error
        }
    };
    useEffect(() => {
        getMenuList(); 
    }, []);

    useEffect(() => {
        if (menuList) {          
            setrowValueflag(false);
        } else {
            setrowValueflag(true);
        }
        if (activeKey === "SelectedAnalystData") {
            setshowAcess(true)
        }
        else {
            setshowAcess(false)
        }
       
    }, [activeKey]);
    const updatemenuAcces = (e, props) => {
        props.node.setDataValue(props.colDef.field, e.target.checked);
        const ds = {
            "contactId": props.data.ContactId,
            "contactWebCategoryId": props.data.ContactWebCategoryId,
            "contactWebCategoryName": props.data.ContactWebCategoryName,
            "assets": props.colDef.field==="Assets"?e.target.checked===false?0:1:props.data.Assets,
            "statements":  props.colDef.field==="Statements"?e.target.checked===false?0:1:props.data.Statements,
            "taxDocuments":  props.colDef.field==="TaxDocuments"?e.target.checked===false?0:1:props.data.TaxDocuments,
            "researchDocuments":  props.colDef.field==="ResearchDocuments"?e.target.checked===false?0:1:props.data.ResearchDocuments
          }
        sbaAxios({
            url: `${insertupdatemenuAcces}`,
            method: 'post',
            data: ds,
        })
            .then((response) => {
                toast.success('Menu Permission Updated Successfully', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                
                getMenuList();
            })
            .catch((error) => {
                console.error(error);
            });
    };
    const CheckboxRendererMenu = (props) => {
        if (props.data.ContactId === 0) {
            setrowValueflag(true)
        };
        return (
            <div className="d-flex justify-content-start align-items-center h-100" style={{ paddingLeft: '10px' }}>
                <input
                    type="checkbox"
                    checked={props.value}
                    onChange={(e) => {
                        updatemenuAcces(e,props);
                    }}
                    disabled={props.data.ContactId===0?true:false || props.colDef.field==="Assets" }
                />
            </div>
        );
    };
    const columnDefs = [
        { headerName: "Assets", field: "Assets", editable: false,cellRenderer: CheckboxRendererMenu },
        { headerName: "Statements", field: "Statements", editable: false, cellRenderer: CheckboxRendererMenu },
        { headerName: "Tax Documents", field: "TaxDocuments", editable: false, cellRenderer: CheckboxRendererMenu },
        { headerName: "Research Documents", field: "ResearchDocuments", editable: false, cellRenderer: CheckboxRendererMenu },
    ];
    const renderComponent = () => {
        
        if (activeKey === 'DelegateAnalystData') {
            return <DelegateAnalystData />;
        } else {
           
            return <SelectedAnalystData />;
            
        }
    };
   
    const Copyclk = () => {
        setcopyAcess(true);
    }
    const Addclk = () => {
        setaddAcess(true);      
    }
    const [groupDefaultExpanded, setGroupDefaultExpanded] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpandCollapse = () => {
        if (isExpanded) {
            setGroupDefaultExpanded(0); // Collapse all
        } else {
            setGroupDefaultExpanded(-1); // Expand all
        }
        setIsExpanded(!isExpanded);
    };
    //Grant Access 
 const SelectedAnalystData = () => {
        const [portalList, setPortalList] = useState([]);
        const [rowData, setRowData] = useState([]);
        const [detailData, setDetailData] = useState([]);
        const params = useParams();
        const [deleteModal, setDeleteModal] = useState();
        const [contactid, setContactId] = useState();
        const [taxentityid, setTaxEntityId] = useState();
        const [render, setRender] = useState(false);
        
        const getPortalList = async () => {
            
            try {
                setIsgrantedAccessLoading(true);
                const response = await sbaAxios({ url: `${getGrantedPortalAccessAPI}${params.ContactId}` });
                setIsgrantedAccessLoading(false);
                return response; // Assuming the data you need is in response.data
               
            } catch (error) {
               
                console.error("Error fetching portal list:", error);
                setIsgrantedAccessLoading(false);
                return []; // Return an empty array on error
            }
     };

        useEffect(() => {
            const fetchData = async () => {
                try {
                   
                    const portalData = await getPortalList();
                    setPortalList(portalData || []);
                   
                } catch (error) {
                    console.error("Error fetching portal list:", error);
                }
            };

            fetchData();
        }, [params.ContactId,render]);


        useEffect(() => {
            if (portalList && portalList.length > 0) {
                const formattedData = portalList.map(item => ({
                    id: item.ContactId,
                    InvestorContactId: item.InvestorContactId,
                    InvestorName: item.InvestorName,
                    ClientReporting: item.ClientReporting === 1,
                    //AssetAccess: item.AssetAccess === 1,
                    AdvisoryAgreement: item.AdvisoryAgreement === 1,
                    Billing: item.Billing === 1,
                    ContactTaxEntityPermissionLst: item.ContactTaxEntityPermissionLst,
                }));



                setRowData(formattedData);
            } else {
                setRowData([]);
            }
        }, [portalList]);

        useEffect(() => {
            if (portalList && portalList.length > 0) {


                const formattedDatas = portalList.flatMap(item => {
                    if (item.ContactTaxEntityPermissionLst) {


                        return item.ContactTaxEntityPermissionLst.map(permission => ({
                            id: permission.ContactId,
                            InvestorContactId: item.InvestorContactId,
                            taxEntityId: permission.TaxEntityId,
                            AccountName: permission.TaxEntityName,
                            ClientReporting: permission.ClientReporting === 1,
                            SbaTaxReporting: permission.SBATaxReporting === 1,
                            TaxReporting: permission.TaxReporting === 1,
                            ManagerCommentary: permission.ManagerCommentary === 1,
                            FinancialStatements: permission.FinancialStatements === 1,
                            AdvAgreement: permission.AdvisoryAgreement === 1,
                            Billing: permission.Billing === 1,
                            Presentation: permission.Presentations === 1,
                            ManagerStatements: permission.ManagerStatements === 1,
                            Transactions: permission.Transactions === 1,
                            InsuranceStatements: permission.InsuranceStatements === 1,
                            CapCallDistribution: permission.CapCallDistribution === 1,
                            QuarterlyLetter: permission.QuarterlyLetter === 1,
                            InsuranceDocsAndReporting: permission.InsuranceDocsAndReporting === 1,
                            TaxPlanning: permission.TaxPlanning === 1,
                            LegalDocs: permission.LegalDocs === 1,
                            GenSpringClientReporting: permission.GenSpringClientReporting === 1,
                            DueDiligenceMaterials: permission.DueDiligenceMaterials === 1,
                            OtherLegalDocuments: permission.OtherLegalDocuments === 1,
                            PersonalDocuments: permission.PersonalDocuments === 1,
                            LegalDocuments: permission.LegalDocuments === 1,
                            OtherMiscDocuments: permission.OtherMiscDocuments === 1,
                            OtherPrivate: permission.OtherPrivate === 1,
                            ExecutedDocumentsBinder1: permission.ExecutedDocumentsBinder1 === 1,
                            ExecutedDocumentsBinder2: permission.ExecutedDocumentsBinder2 === 1,
                            DueDiligenceMemos: permission.DueDiligenceMemos === 1,
                            EmailStatement: permission.EmailStatement === 1,
                            ManagerDocument: permission.ManagerDocument === 1,
                            FaxStatement: permission.FaxStatement === 1,
                            ConsolidatedStatement: permission.ConsolidatedStatement === 1,
                        }));
                    } else {

                        return [];
                    }
                });


                setDetailData(formattedDatas);
            } else {
                setDetailData([]);
            }
        }, [portalList]);

        const updateTaxEntity = (e, props) => {
            props.node.setDataValue(props.colDef.field, e.target.checked);
            const ds = {
                "contactId": props.data.id,
                "taxEntityId": props.data.taxEntityId,
                "accessName": props.colDef.field,
                "isChecked": e.target.checked,
                "modifiedBy": 0
            }
            sbaAxios({
                url: `${updatetaxEntityAccess}`,
                method: 'post',
                data: ds,
            })
                .then((response) => {
                    toast.success('Tax Entity Updated  Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })

                })

                .catch((error) => {
                    console.error(error);
                });

        }
        const CheckboxRenderer = (props) => {
            const checked = props.value === true;
            return (
                <div className="d-flex justify-content-center align-items-center h-100">
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={(e) => {
                            updateTaxEntity(e, props);
                        }}
                    />
                </div>
            );
        };
        const parentCheckboxRenderer = (props) => {
            const checked = props.value === true;
            return (
                <div className="d-flex justify-content-start align-items-center h-100" style={{ paddingLeft: '10px' }}>
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={(e) => parentupdateTaxEntity(e, props)}
                    />
                </div>
            );
        };

     const parentupdateTaxEntity = (e, props) => {
         props.node.setDataValue(props.colDef.field, e.target.checked);
         const ds = {
             "contactId": props.data.id,
             "InvestorContactId": props.data.InvestorContactId,
             "accessName": props.colDef.field,
             "isChecked": e.target.checked,
             "modifiedBy": 0
         };
         sbaAxios({
             url: `${updateInvestorWebAcces}`,
             method: 'post',
             data: ds,
         })
             .then(async (response) => {
                 toast.success('Tax Entity Updated Successfully', {
                     position: "top-right",
                     autoClose: 5000,
                     hideProgressBar: false,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     progress: undefined,
                     theme: "light",
                 });

                 // Call getPortalList after showing success message
                 const portalListResponse = await getPortalList();
                 // You can handle the response if needed
                 console.log('Portal List Response:', portalListResponse);
             })
             .catch((error) => {
                 console.error(error);
             });
     };
     
        const columnDefs = [
            { headerName: "Investor Name", field: "InvestorName", cellRenderer: 'agGroupCellRenderer' },
            { headerName: "Client Reporting", field: "ClientReporting", editable: true, cellRenderer: parentCheckboxRenderer, width: 150 },
            { headerName: "Advisory Agreement", field: "AdvisoryAgreement", editable: true, cellRenderer: parentCheckboxRenderer, width: 150 },
            { headerName: "Billing", field: "Billing", editable: true, cellRenderer: parentCheckboxRenderer, width: 150 },
        ];

        const autoGroupColumnDef = {
            headerName: "",
            minWidth: 250,
            // cellRendererParams: {
            //     suppressCount: true,

            // },
        };
        const deletePermission = () => {
            sbaAxios({ url: `${deletetaxentityAcces}${contactid},${taxentityid}` })
                .then((res) => {
                    setRender(val => !val);
                    setDeleteModal(false);
                    SBNotify({
                        Msg: "Selected Permission Deleted Successfully",
                        type: "success",
                    });

                })
                .catch((error) => {
                    SBNotify({ Msg: error, type: "error" });
                });




        };
        const ActionsRenderer = (props) => {
            const contactId = props.data.id;
            const taxentityId = props.data.taxEntityId;

            const handleDeleteClick = () => {

                {
                    setTaxEntityId(taxentityId);
                    setContactId(contactId);
                    setDeleteModal(true);
                }
            }
            return (
                <div className="actions-cell">

                    <i className="fa fa-trash" style={{ color: "red", margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick}></i>
                </div>)

        };
        const detailCellRendererParams = useMemo(() => ({
            detailGridOptions: {
                columnDefs: [
                    { headerName: "", field: "", cellRenderer: ActionsRenderer },
                    { headerName: "Account Name", field: "AccountName" },
                    { headerName: "Client Reporting", field: "ClientReporting", cellRenderer: CheckboxRenderer },
                    { headerName: "SBA Tax Reporting", field: "SbaTaxReporting", cellRenderer: CheckboxRenderer },
                    { headerName: "Tax Reporting", field: "TaxReporting", cellRenderer: CheckboxRenderer },
                    { headerName: "Manager Commentary", field: "ManagerCommentary", cellRenderer: CheckboxRenderer },
                    { headerName: "Financial Statements", field: "FinancialStatements", cellRenderer: CheckboxRenderer },
                    { headerName: "Advisory Agreement", field: "AdvisoryAgreement", cellRenderer: CheckboxRenderer },
                    { headerName: "Billing", field: "Billing", cellRenderer: CheckboxRenderer },
                    { headerName: "Presentation", field: "Presentations", cellRenderer: CheckboxRenderer },
                    { headerName: "Manager Statements", field: "ManagerStatements", cellRenderer: CheckboxRenderer },
                    { headerName: "Transactions", field: "Transactions", cellRenderer: CheckboxRenderer },
                    { headerName: "Insurance Statements", field: "InsuranceStatements", cellRenderer: CheckboxRenderer },
                    { headerName: "CapCall/Distribution", field: "CapCallDistribution", cellRenderer: CheckboxRenderer },
                    { headerName: "Quarterly Letter", field: "QuarterlyLetter", cellRenderer: CheckboxRenderer },
                    { headerName: "Insurance Docs And Reporting", field: "InsuranceDocsAndReporting", cellRenderer: CheckboxRenderer },
                    { headerName: "Tax Planning", field: "TaxPlanning", cellRenderer: CheckboxRenderer },
                    { headerName: "Legal Docs", field: "LegalDocs", cellRenderer: CheckboxRenderer },
                    { headerName: "GenSpring Client Reporting", field: "GenSpringClientReporting", cellRenderer: CheckboxRenderer },
                    { headerName: "DueDiligence Materials", field: "DueDiligenceMaterials", cellRenderer: CheckboxRenderer },
                    { headerName: "Other Legal Documents(AII)", field: "OtherLegalDocuments", cellRenderer: CheckboxRenderer },
                    { headerName: "Personal Documents", field: "PersonalDocuments", cellRenderer: CheckboxRenderer },
                    { headerName: "Legal Documents", field: "LegalDocuments", cellRenderer: CheckboxRenderer },
                    { headerName: "Other MiscDocuments", field: "OtherMiscDocuments", cellRenderer: CheckboxRenderer },
                    { headerName: "Other Private", field: "OtherPrivate", cellRenderer: CheckboxRenderer },
                    { headerName: "Executed DocumentsBinder1", field: "ExecutedDocumentsBinder1", cellRenderer: CheckboxRenderer },
                    { headerName: "Executed DocumentsBinder2", field: "ExecutedDocumentsBinder2", cellRenderer: CheckboxRenderer },
                    { headerName: "Due Diligence Memos", field: "DueDiligenceMemos", cellRenderer: CheckboxRenderer },
                    { headerName: "Email Statement", field: "EmailStatement", cellRenderer: CheckboxRenderer },
                    { headerName: "Manager Document", field: "ManagerDocument", cellRenderer: CheckboxRenderer },
                    { headerName: "Fax Statement", field: "FaxStatement", cellRenderer: CheckboxRenderer },
                    { headerName: "Consolidated Statement", field: "ConsolidatedStatement", cellRenderer: CheckboxRenderer },
                ],
                defaultColDef: {
                    flex: 1,
                    minWidth: 150,
                    resizable: true,
                },
            },
       
           
            getDetailRowData: (params) => {
                const parentId = params.data.id;
                const parentInvestorContactId = params.data.InvestorContactId;
                console.log("Fetching details for parent ID:", parentId, "and InvestorContactId:", parentInvestorContactId); // Debug log
                // Locate the parent item using both ContactId and InvestorContactId
                const parentItem = portalList.find(item => item.ContactId === parentId && item.InvestorContactId === parentInvestorContactId);
                console.log("Matched parent item:", parentItem); // Debug log
                if (params.data.ContactTaxEntityPermissionLst.length > 0) {
                    if (parentItem && parentItem.ContactTaxEntityPermissionLst && parentItem.ContactTaxEntityPermissionLst.length > 0) {
                        const filteredPermissions = parentItem.ContactTaxEntityPermissionLst.filter(permission => permission.InvestorContactId === parentInvestorContactId);
                        console.log("Filtered permissions for InvestorContactId:", parentInvestorContactId, filteredPermissions);
                        const formattedDatas = filteredPermissions.map(permission => ({
                            id: permission.ContactId,
                            taxEntityId: permission.TaxEntityId,
                            AccountName: permission.TaxEntityName,
                            ClientReporting: permission.ClientReporting === 1,
                            SbaTaxReporting: permission.SBATaxReporting === 1,
                            TaxReporting: permission.TaxReporting === 1,
                            FinancialStatements: permission.FinancialStatements===1,
                            ManagerCommentary: permission.ManagerCommentary === 1,
                            ClientReporting: permission.ClientReporting === 1,
                            AdvisoryAgreement: permission.AdvisoryAgreement === 1,
                            Billing: permission.Billing === 1,
                            Presentations: permission.Presentations === 1,
                            ManagerStatements: permission.ManagerStatements === 1,
                            Transactions: permission.Transactions === 1,
                            InsuranceStatements: permission.InsuranceStatements === 1,
                            CapCallDistribution: permission.CapCallDistribution === 1,
                            QuarterlyLetter: permission.QuarterlyLetter === 1,
                            InsuranceDocsAndReporting: permission.InsuranceDocsAndReporting === 1,
                            TaxPlanning: permission.TaxPlanning === 1,
                            LegalDocs: permission.LegalDocs === 1,
                            GenSpringClientReporting: permission.GenSpringClientReporting === 1,
                            DueDiligenceMaterials: permission.DueDiligenceMaterials === 1,
                            OtherLegalDocuments: permission.OtherLegalDocuments === 1,
                            PersonalDocuments: permission.PersonalDocuments === 1,
                            LegalDocuments: permission.LegalDocuments === 1,
                            OtherMiscDocuments: permission.OtherMiscDocuments === 1,
                            OtherPrivate: permission.OtherPrivate === 1,
                            ExecutedDocumentsBinder1: permission.ExecutedDocumentsBinder1 === 1,
                            ExecutedDocumentsBinder2: permission.ExecutedDocumentsBinder2 === 1,
                            DueDiligenceMemos: permission.DueDiligenceMemos === 1,
                            EmailStatement: permission.EmailStatement === 1,
                            ManagerDocument: permission.ManagerDocument === 1,
                            FaxStatement: permission.FaxStatement === 1,
                            ConsolidatedStatement: permission.ConsolidatedStatement === 1,
                        }));

                        params.successCallback(formattedDatas);
                    }
                }
                else {
                    params.successCallback([]); // If ContactTaxEntityPermissionLst is empty, do not load the detail grid
                }
            },
        }), [portalList]);
        const expandAll = () => {
            setGroupDefaultExpanded(-1);
        };
        return (

            <>
              {IsgrantedAccessLoading ? <><LoadingScreen/></> :
                <div id="granted" className="ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
                    <AgGridReact
                        columnDefs={columnDefs}
                        rowData={rowData}
                        masterDetail={true}
                        detailCellRendererParams={detailCellRendererParams}
                        defaultColDef={{ flex: 1 }}
                        autoGroupColumnDef={autoGroupColumnDef}
                        getRowNodeId={(data) => data.id}
                       
                        groupDefaultExpanded={groupDefaultExpanded}
                    />
                </div>
    }

                <DeleteConfirmationModal open={deleteModal} setOpen={setDeleteModal} contactId={contactid} taxEntityId={taxentityid} setRender={setRender} deletePermission={deletePermission}/>
            </>
        );
    };
  const DelegateAnalystData = () =>
    {
        const [portalList, setPortalList] = useState([]);
        const [rowData, setRowData] = useState([]);
        const [detailData, setDetailData] = useState([]);
        const params = useParams();
        const [deleteModal, setDeleteModal] = useState();
        const [contactid, setContactId] = useState();
        const [taxentityid, setTaxEntityId] = useState();
        const [render, setRender] = useState(false);
        const getPortalList = async () => {
            try {
                const response = await sbaAxios({ url: `${getDelegatePortalAccessAPI}${params.ContactId}` });
                return response; // Assuming the data you need is in response.data
            } catch (error) {
                console.error("Error fetching portal list:", error);
                return []; // Return an empty array on error
            }
        };

        useEffect(() => {
            const fetchData = async () => {
                try {
                    setIsdelegatedAccessLoading(true);
                    const portalData = await getPortalList();
                    setPortalList(portalData || []);
                    setIsdelegatedAccessLoading(false);
                } catch (error) {
                    console.error("Error fetching portal list:", error);
                }
            };

            fetchData();
        }, [params.ContactId, render]); // Ensure this useEffect runs when ContactId changes

        useEffect(() => {
            if (portalList && portalList.length > 0) {
                const formattedData = portalList.map(item => ({
                    id: item.ContactId,
                    InvestorContactId: item.InvestorContactId,
                    InvestorName: item.InvestorName,
                    ClientReporting: item.ClientReporting === 1,
                    //AssetAccess: item.AssetAccess === 1,
                    AdvisoryAgreement: item.AdvisoryAgreement === 1,
                    Billing: item.Billing === 1,
                    ContactTaxEntityPermissionLst: item.ContactTaxEntityPermissionLst,
                }));
                setRowData(formattedData);
            } else {
                setRowData([]);
            }
        }, [portalList]);

        useEffect(() => {
            if (portalList && portalList.length > 0) {
                const formattedDatas = portalList.flatMap(item => {
                    return (item.ContactTaxEntityPermissionLst || []).map(permission => ({
                       // parentContactId: item.ContactId,  // Add parentContactId reference
                        id: permission.ContactId,
                        investorContactId: permission.InvestorContactId,
                        taxEntityId: permission.TaxEntityId,
                        AccountName: permission.TaxEntityName,
                        ClientReporting: permission.ClientReporting === 1,
                        SbaTaxReporting: permission.SBATaxReporting === 1,
                        TaxReporting: permission.TaxReporting === 1,
                        ManagerCommentary: permission.ManagerCommentary === 1,
                        ClientReporting: permission.ClientReporting === 1,
                        AdvAgreement: permission.AdvisoryAgreement === 1,
                        Billing: permission.Billing === 1,
                        Presentation: permission.Presentations === 1,
                        ManagerStatements: permission.ManagerStatements === 1,
                        Transactions: permission.Transactions === 1,
                        InsuranceStatements: permission.InsuranceStatements === 1,
                        CapCallDistribution: permission.CapCallDistribution === 1,
                        QuarterlyLetter: permission.QuarterlyLetter === 1,
                        InsuranceDocsAndReporting: permission.InsuranceDocsAndReporting === 1,
                        TaxPlanning: permission.TaxPlanning === 1,
                        LegalDocs: permission.LegalDocs === 1,
                        GenSpringClientReporting: permission.GenSpringClientReporting === 1,
                        DueDiligenceMaterials: permission.DueDiligenceMaterials === 1,
                        OtherLegalDocuments: permission.OtherLegalDocuments === 1,
                        PersonalDocuments: permission.PersonalDocuments === 1,
                        LegalDocuments: permission.LegalDocuments === 1,
                        OtherMiscDocuments: permission.OtherMiscDocuments === 1,
                        OtherPrivate: permission.OtherPrivate === 1,
                        ExecutedDocumentsBinder1: permission.ExecutedDocumentsBinder1 === 1,
                        ExecutedDocumentsBinder2: permission.ExecutedDocumentsBinder2 === 1,
                        DueDiligenceMemos: permission.DueDiligenceMemos === 1,
                        EmailStatement: permission.EmailStatement === 1,
                        ManagerDocument: permission.ManagerDocument === 1,
                        FaxStatement: permission.FaxStatement === 1,
                        ConsolidatedStatement: permission.ConsolidatedStatement === 1,
                    }));
                });
                setDetailData(formattedDatas);
            } else {
                setDetailData([]);
            }
        }, [portalList]);

        const CheckboxRenderer = (props) => {
            const checked = props.value === true;
            return (
                <div className="d-flex justify-content-start align-items-center h-100" style={{ paddingLeft: '10px' }}>
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={(e) => updateinvestorWebAcces(e, props)}
                    />
                </div>
            );
        };
        const parentCheckboxRenderer = (props) => {
            const checked = props.value === true;
            return (
                <div className="d-flex justify-content-start align-items-center h-100" style={{ paddingLeft: '10px' }}>
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={(e) => parentupdateinvestorWebAcces(e, props)}
                    />
                </div>
            );
        };
        const columnDefs = [
            { headerName: "Investor Name", field: "InvestorName", cellRenderer: 'agGroupCellRenderer' },
            { headerName: "Client Reporting", field: "ClientReporting", editable: true, cellRenderer: parentCheckboxRenderer, width: 150 },
            { headerName: "Advisory Agreement", field: "AdvisoryAgreement", editable: true, cellRenderer: parentCheckboxRenderer, width: 150 },
            { headerName: "Billing", field: "Billing", editable: true, cellRenderer: parentCheckboxRenderer, width: 150 },
        ];

        const autoGroupColumnDef = {
            headerName: "",
            minWidth: 250,
            cellRendererParams: {
                suppressCount: true,
            },
        };
        const parentupdateinvestorWebAcces = (e, props) => {
            props.node.setDataValue(props.colDef.field, e.target.checked);
            const ds = {
                "contactId": props.data.InvestorContactId,
                "investorContactId":  props.data.id,
                "accessName": props.colDef.field,
                "isChecked": e.target.checked,
                "modifiedBy": 0

            };
            sbaAxios({
                url: `${updateInvestorWebAcces}`,
                method: 'post',
                data: ds,
            })
                .then((response) => {
                    toast.success('Tax Entity Updated Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                })
                .catch((error) => {
                    console.error(error);
                });
        };

        const updateinvestorWebAcces = (e, props) => {
            props.node.setDataValue(props.colDef.field, e.target.checked);
            const ds = {
                "contactId": props.data.investorContactId,
                "TaxEntityId": props.data.taxEntityId,
                "accessName": props.colDef.field,
                "isChecked": e.target.checked,
                "modifiedBy": 0
            };
            sbaAxios({
                url: `${updatetaxEntityAccess}`,
                method: 'post',
                data: ds,
            })
                .then((response) => {
                    toast.success('Tax Entity Updated Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                })
                .catch((error) => {
                    console.error(error);
                });
        };


        const ActionsRenderer = (props) => {
            const contactId = props.data.investorContactId;
            const taxentityId = props.data.taxEntityId;

            const handleDeleteClick = () => {

                {
                    setTaxEntityId(taxentityId);
                    setContactId(contactId);
                    setDeleteModal(true);
                }
            }
            return (
                <div className="actions-cell">

                    <i className="fa fa-trash" style={{ color: "red", margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick}></i>
                </div>)

        };
        const detailCellRendererParams = useMemo(() => ({
            detailGridOptions: {
                columnDefs: [
                    { headerName: "", field: "", cellRenderer: ActionsRenderer },
                    { headerName: "Account Name", field: "AccountName" },
                    { headerName: "Client Reporting", field: "ClientReporting", cellRenderer: CheckboxRenderer },
                    { headerName: "SBA Tax Reporting", field: "SbaTaxReporting", cellRenderer: CheckboxRenderer },
                    { headerName: "Tax Reporting", field: "TaxReporting", cellRenderer: CheckboxRenderer },
                    { headerName: "Manager Commentary", field: "ManagerCommentary", cellRenderer: CheckboxRenderer },
                    { headerName: "Client Reporting", field: "ClientReporting", cellRenderer: CheckboxRenderer },
                    { headerName: "Advisory Agreement", field: "AdvAgreement", cellRenderer: CheckboxRenderer },
                    { headerName: "Billing", field: "Billing", cellRenderer: CheckboxRenderer },
                    { headerName: "Presentation", field: "Presentation", cellRenderer: CheckboxRenderer },
                    { headerName: "Manager Statements", field: "ManagerStatements", cellRenderer: CheckboxRenderer },
                    { headerName: "Transactions", field: "Transactions", cellRenderer: CheckboxRenderer },
                    { headerName: "Insurance Statements", field: "InsuranceStatements", cellRenderer: CheckboxRenderer },
                    { headerName: "CapCall/Distribution", field: "CapCallDistribution", cellRenderer: CheckboxRenderer },
                    { headerName: "Quarterly Letter", field: "QuarterlyLetter", cellRenderer: CheckboxRenderer },
                    { headerName: "Insurance Docs And Reporting", field: "InsuranceDocsAndReporting", cellRenderer: CheckboxRenderer },
                    { headerName: "Tax Planning", field: "TaxPlanning", cellRenderer: CheckboxRenderer },
                    { headerName: "Legal Docs", field: "LegalDocs", cellRenderer: CheckboxRenderer },
                    { headerName: "GenSpring Client Reporting", field: "GenSpringClientReporting", cellRenderer: CheckboxRenderer },
                    { headerName: "DueDiligence Materials", field: "DueDiligenceMaterials", cellRenderer: CheckboxRenderer },
                    { headerName: "Other Legal Documents(AII)", field: "OtherLegalDocuments", cellRenderer: CheckboxRenderer },
                    { headerName: "Personal Documents", field: "PersonalDocuments", cellRenderer: CheckboxRenderer },
                    { headerName: "Legal Documents", field: "LegalDocuments", cellRenderer: CheckboxRenderer },
                    { headerName: "Other MiscDocuments", field: "OtherMiscDocuments", cellRenderer: CheckboxRenderer },
                    { headerName: "Other Private", field: "OtherPrivate", cellRenderer: CheckboxRenderer },
                    { headerName: "Executed DocumentsBinder1", field: "ExecutedDocumentsBinder1", cellRenderer: CheckboxRenderer },
                    { headerName: "Executed DocumentsBinder2", field: "ExecutedDocumentsBinder2", cellRenderer: CheckboxRenderer },
                    { headerName: "Due Diligence Memos", field: "DueDiligenceMemos", cellRenderer: CheckboxRenderer },
                    { headerName: "Email Statement", field: "EmailStatement", cellRenderer: CheckboxRenderer },
                    { headerName: "Manager Document", field: "ManagerDocument", cellRenderer: CheckboxRenderer },
                    { headerName: "Fax Statement", field: "FaxStatement", cellRenderer: CheckboxRenderer },
                    { headerName: "Consolidated Statement", field: "ConsolidatedStatement", cellRenderer: CheckboxRenderer },
                ],
                defaultColDef: {
                    flex: 1,
                    minWidth: 150,
                    resizable: true,
                },
            },
            getDetailRowData: (params) => {
                const parentId = params.data.id;
                const parentInvestorContactId = params.data.InvestorContactId;
                console.log("Fetching details for parent ID:", parentId, "and InvestorContactId:", parentInvestorContactId); // Debug log

                // Locate the parent item using both ContactId and InvestorContactId
                const parentItem = portalList.find(item => item.ContactId === parentId && item.InvestorContactId === parentInvestorContactId);
                console.log("Matched parent item:", parentItem); // Debug log

                if (parentItem && parentItem.ContactTaxEntityPermissionLst && parentItem.ContactTaxEntityPermissionLst.length > 0) {
                    // Filter the permissions to match the specific InvestorContactId
                    const filteredPermissions = parentItem.ContactTaxEntityPermissionLst.filter(permission => permission.InvestorContactId === parentInvestorContactId);
                    console.log("Filtered permissions for InvestorContactId:", parentInvestorContactId, filteredPermissions); // Debug log

                    // Map the filtered permissions to the required format
                    const formattedDatas = filteredPermissions.map(permission => ({
                        id: permission.ContactId,
                        taxEntityId: permission.TaxEntityId,
                        investorContactId: permission.InvestorContactId,
                        AccountName: permission.TaxEntityName,
                        ClientReporting: permission.ClientReporting === 1,
                        SbaTaxReporting: permission.SBATaxReporting === 1,
                        TaxReporting: permission.TaxReporting === 1,
                        ManagerCommentary: permission.ManagerCommentary === 1,
                        ClientReporting: permission.ClientReporting === 1,
                        AdvAgreement: permission.AdvisoryAgreement === 1,
                        Billing: permission.Billing === 1,
                        Presentation: permission.Presentations === 1,
                        ManagerStatements: permission.ManagerStatements === 1,
                        Transactions: permission.Transactions === 1,
                        InsuranceStatements: permission.InsuranceStatements === 1,
                        CapCallDistribution: permission.CapCallDistribution === 1,
                        QuarterlyLetter: permission.QuarterlyLetter === 1,
                        InsuranceDocsAndReporting: permission.InsuranceDocsAndReporting === 1,
                        TaxPlanning: permission.TaxPlanning === 1,
                        LegalDocs: permission.LegalDocs === 1,
                        GenSpringClientReporting: permission.GenSpringClientReporting === 1,
                        DueDiligenceMaterials: permission.DueDiligenceMaterials === 1,
                        OtherLegalDocuments: permission.OtherLegalDocuments === 1,
                        PersonalDocuments: permission.PersonalDocuments === 1,
                        LegalDocuments: permission.LegalDocuments === 1,
                        OtherMiscDocuments: permission.OtherMiscDocuments === 1,
                        OtherPrivate: permission.OtherPrivate === 1,
                        ExecutedDocumentsBinder1: permission.ExecutedDocumentsBinder1 === 1,
                        ExecutedDocumentsBinder2: permission.ExecutedDocumentsBinder2 === 1,
                        DueDiligenceMemos: permission.DueDiligenceMemos === 1,
                        EmailStatement: permission.EmailStatement === 1,
                        ManagerDocument: permission.ManagerDocument === 1,
                        FaxStatement: permission.FaxStatement === 1,
                        ConsolidatedStatement: permission.ConsolidatedStatement === 1,
                    }));

                    console.log("Formatted data for parent:", parentId, "and InvestorContactId:", parentInvestorContactId, formattedDatas); // Debug log
                    params.successCallback(formattedDatas);
                } else {
                    console.log("No permissions found for parent:", parentId, "and InvestorContactId:", parentInvestorContactId); // Debug log
                    params.successCallback([]); // No child records to load
                }
            },

        }), [portalList]);

        const deletedelegatedAccess =  () => {
                sbaAxios({ url: `${deletetaxentityAcces}${contactid},${taxentityid}` })
                    .then((res) => {
                        setRender(val => !val);
                        setDeleteModal(false);
                        SBNotify({
                            Msg: "Selected Permission Deleted Successfully",
                            type: "success",
                        });
    
                    })
                    .catch((error) => {
                        SBNotify({ Msg: error, type: "error" });
                    });
    
    
    
    
           
        }

        return (
            <>
             {IsdelegateAccessLoading ? <><LoadingScreen/></> :
                <div id="delegate" className="ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
                    <AgGridReact
                        columnDefs={columnDefs}
                        rowData={rowData}
                        masterDetail={true}
                        detailCellRendererParams={detailCellRendererParams}
                        defaultColDef={{ flex: 1 }}
                        autoGroupColumnDef={autoGroupColumnDef}
                        getRowNodeId={(data) => data.id}
                        groupDefaultExpanded={groupDefaultExpanded}

                    />
                </div>
    }
                <DeleteConfirmationModal open={deleteModal} setOpen={setDeleteModal}  deletePermission={deletedelegatedAccess} />
            </>
        );
    };

 return (
    <div>
        
        <div class="col-md-3 ms-md-3">
            <div class="d-flex align-items-center mb-4">
                <span class="fw-medium me-2">Web Category:</span>
                     <p class="fw-medium mb-0">Investor</p>
             </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="d-flex">
                    <div className="p-3" style={{ marginTop: '50px', marginleft: '-70px' }}>
                        <h5>Menu Access</h5>
                     </div>
                     <div className="ag-theme-alpine" style={{ height: "109px", width: "60%", marginBottom: '30px', }}>
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={rowValue}
                            getRowNodeId={(data) => data.id} 
                            defaultColDef={{ flex: 1 }}
                        />
                     </div>                                                      
                 </div>
                 {rowValueflag && (
                     <span style={{ alignSelf: 'center', marginLeft: '200px', color: 'red'}}>
                         Please setup Web Details (Web Category, Web UserId, and Web Status) to enable Web Menu Access
                     </span>
                 )}
            </div>
        </div>
        <div></div>
        <br />
        <div className="col-md-12">
            <div className="d-flex justify-content-end">
                <button type="button" className="p-sm-btn mx-1" onClick={toggleExpandCollapse}>
                    <i className="fa-solid" /> {isExpanded ? 'Collapse All' : 'Expand All'}
                </button>
                 {showAcess && (
                     <>
                         <button type="submit" className="p-sm-btn mx-1" onClick={Copyclk}>
                             <i className="fa-solid" /> Copy Access
                          </button>
                         <button type="submit" className="p-sm-btn mx-1" onClick={Addclk}>
                             <i className="fa-solid" /> Add Access
                         </button>
                     </>
                 )}

            </div>
        </div>
        <div className="asset-detail-screen" >
            <Tabs activeKey={activeKey} onSelect={(k) => setActiveKey(k)  }>
                
                <Tab eventKey="DelegateAnalystData" title="Delegated Access">
                    {activeKey === 'DelegateAnalystData' }
                </Tab>
                <Tab eventKey="SelectedAnalystData" title="Granted Access">
                    {activeKey === 'SelectedAnalystData' }
                </Tab>
            </Tabs>              
            {renderComponent()}
        </div>
         {addAcess && <AddAccessDrawer open={addAcess} setOpen={setaddAcess} />}
        {copyAcess &&<CopyAccessDrawer open={copyAcess} setOpen={setcopyAcess}></CopyAccessDrawer>}
    </div>
);
};

const DeleteConfirmationModal = ({ open, setOpen,deletePermission }) => {
     
        return <Modal show={open}>
            <Modal.Header
                closeButton
                onClick={() => {
                    setOpen(false);
                }}
            >
                <Modal.Title>
                    Delete Permission
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>The selected Permission will be deleted and can not be recovered. Are you sure?</p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="s-sm-btn mx-1"
                    onClick={() => { setOpen(false) }}
                >
                    Cancel
                </button>
                <button
                    className="p-sm-btn mx-1"
                    onClick={deletePermission}
                >
                    Yes
                </button>
            </Modal.Footer>
        </Modal>
    };
const AddAccessDrawer=({open,setOpen,setRender})=>
    { 
        const dispatch = useDispatch();
        const params = useParams();
        const [contactData, setcontactData] = useState([]);
        const [accountData, setaccountData] = useState([]);
        const [selectedcontact, setselectedcontact] = useState([]);
        const [selectedaccount, setselectedaccount] = useState([]);
        const [SelectedWebRoles, setSelectedWebRoles] = useState([]);
        const [WebRoles, setWebRoles] = useState([]);
        const [WebGriddata,setWebGriddata]= useState([]);
    const [selectedPermission, setselectedPermission] = useState({ "ActivityEntityType":"Account", "ActivityEntityTypeId":1});
        const ActivityentityType = useSelector((state) => state.ActivityentityType.ActivityentityType) || [];
        const PermissionData = ActivityentityType?.filter(item => item.ActivityEntityTypeId !== -1)
        useEffect(() => {
        GetAvaialbleTaxEntitie("");
        GetAvailableInvestors("");
            dispatch(getActivityEntityType(2));
            if (selectedPermission.ActivityEntityType === "Contact") {
                GetWebRoles(true);
            } else {
                GetWebRoles(false);
            }
        },[])

        // Add access drawer control onchange 
    const Webrolechange = (event) => {
        setSelectedWebRoles(event.value);
        GetWebRoleDefaultAccess(event.value.WebContactRoleId);
    }
        const Contactchange = (e) => {
            if (e.value) {
                setselectedcontact(e.value);
            }
    }
    const Accountchange = (e) => {
        if (e.value) {
            setselectedaccount(e.value);
        }
    }
    const Permissionchange = (event) => {
        setselectedcontact([]);
        setselectedaccount([]);
        setSelectedWebRoles([]);
        setWebGriddata([]);
        setselectedPermission(event.value);
        if (event.value.ActivityEntityType === "Contact") {
            GetWebRoles(true);
        } else {
            GetWebRoles(false);
        }
    }
        const GetAvaialbleTaxEntitie = async (terms) => {

            const response = await sbaAxios({
                url: `${getAvaialbleTaxEntitie}?contactId=${params.ContactId}&searchText=${terms}`,
                method: 'get',
            });

            const account = response?.length > 0
                ? response.sort((a, b) => a.TaxEntityName.localeCompare(b.TaxEntityName))
                : [];
            setaccountData(account);
        }
        const GetAvailableInvestors = async (terms) => {
    
            const response = await sbaAxios({
                url: `${getAvailableInvestors}?contactId=${params.ContactId}&searchText=${terms}`,
                method: 'get',
            });
           const contact = response?.length > 0 
        ? response.sort((a, b) => a.ContactName.localeCompare(b.ContactName))
        : [];
            setcontactData(contact);

        }
        const GetWebRoles = async (Isaccess) => {
    
            const response = await sbaAxios({
                url: `${getWebRoles}/isContactLevelAccess?isContactLevelAccess=${Isaccess}`,
                method: 'get',
            });
            setWebRoles(response);
        }
        const GetWebRoleDefaultAccess = async (webroleId) => {
           
            const response = await sbaAxios({
                url: `${getWebRoleDefaultAccess}${webroleId}`,
                method: 'get',
            });
            if (response) {
                setWebGriddata(response)     
            }
            else {
                setWebGriddata([]);
            }
        }
        const GridCheckboxRenderer = (props) => {    
            const isAddded = props.data.IsChecked;
            const AccessData = props.data;
            return (
                <div className="actions-cell">
                    <input type='checkbox' className="SBA_hand" checked={isAddded} onChange={(e) => {
                        setWebGriddata(value => (value.map(item => {
                            if (item.WebContactAccessId === AccessData.WebContactAccessId) {
                                return { ...item, 'IsChecked': e.target.checked }
                            }
                            else {
                                return { ...item }
                            }
                        }
                        )))
                    }} />
                </div>
            );
        }
        
        const WebcolumnDefs = [
            {
                headerName: 'Access',
                field: 'IsChecked',
                cellRenderer: GridCheckboxRenderer,
                maxWidth: 80
            },
            { headerName: "Document Type", field: "WebContactAccessName" },
    
    
        ];
        
    const closeaccess = () => {
        setselectedcontact([]);
        setselectedaccount([]);
        setSelectedWebRoles([]);
        setWebGriddata([]);
        setOpen(false);
    };

   
    const SaveAccess = () => {            
            let ifsave = true;           
            const savedata = {};
            const webaccessdata = WebGriddata.map((item) => ({
                "webAccessId": item.WebContactAccessId,
                "isChecked": item.IsChecked
            }))
            if (selectedPermission.ActivityEntityType === "Contact") {
                savedata.contactId = params.ContactId;
                savedata.investorContactId = selectedcontact.ContactId;
                savedata.webContactAccessParams = webaccessdata;
            }
            else
            {
                savedata.contactId = params.ContactId;
                savedata.taxEntityId = selectedaccount.TaxEntityId;
                savedata.webContactAccessParams = webaccessdata;
            }
            if (selectedPermission.ActivityEntityType === "Contact") {
                if (!selectedcontact.ContactId) {
                    ifsave = false;
                    SBNotify({ Msg: " Please Select Contact  ", type: "error" });
                }
            }
            else {
                if (!selectedaccount.TaxEntityId) {
                    ifsave = false;
                    SBNotify({ Msg: " Please Select Account ", type: "error" });
                }
            }
            
            
            if (ifsave) {
                if (selectedPermission.ActivityEntityType === "Contact") {
                    sbaAxios({
                        url: `${insertInvestorWebAccess}`,
                        method: "post",
                        data: savedata,
                    }).then((response) => {
                        if (response>0) {
                            SBNotify({ Msg: "Save Contact Access sucessfully" });
                            setselectedcontact([]);
                            setselectedaccount([]);
                            setSelectedWebRoles([]);
                            setWebGriddata([]);
                            setOpen(false);
                            //setRender(val=>val);
                        }
                    }).catch((error) => {
                        SBNotify({ Msg: "sone error  occured", type: "error" });
                    });
                }
                else {
                    sbaAxios({
                        url: `${insertTaxEntityWebAccess}`,
                        method: "post",
                        data: savedata,
                    }).then((response) => {
                        if (response>0) {
                            SBNotify({ Msg: "Save Account Access sucessfully" });
                            setselectedcontact([]);
                            setselectedaccount([]);
                            setSelectedWebRoles([]);
                            setWebGriddata([]);
                            setOpen(false);
                        }
                    }).catch((error) => {
                        SBNotify({ Msg: "sone error  occured", type: "error" });
                    });
                }
            }
    
        };
    return <SBADrawer
    open={open}
    setOpen={setOpen}
    close={false}
    title={"Add Account / Contact Access "}
>
    <div className="drawer">
        <div>
            <div className="mb-4">
                <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12"> Permission Type</label>
                <div>
                    <SBADropDown
                        className="w-50"
                        data={PermissionData}
                        value={selectedPermission}
                        textField={"ActivityEntityType"}
                        valueField={"ActivityEntityTypeId"}
                        onChange={Permissionchange}
                        popupSettings={{ className: "modalDD" }}
                    />
                </div>
            </div>
            <div>
                {selectedPermission.ActivityEntityType === "Contact" ?
                    (<div className="mb-4">
                        <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12"> Contact Name</label>
                        <div>
                                <SBAComboBox
                                className="w-50"                              
                                data={contactData}
                                value={selectedcontact}
                                textField={"ContactName"}
                                valueField={"ContactId"}                             
                                onChange={Contactchange}
                                popupSettings={{ className: "modalDD" }}
                            />
                                                                                                             
                        </div>
                    </div>) :
                    (<div className="mb-4">
                        <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12"> Account Name </label>
                        <div>
                               <SBAComboBox
                                className="w-50"                               
                                data={accountData}
                                value={selectedaccount}
                                textField={"TaxEntityName"}
                                valueField={"TaxEntityId"}                                                                    
                                onChange={Accountchange}
                                popupSettings={{ className: "modalDD" }}

                            />

                        </div>
                    </div>)}
            </div>
            <div className="mb-4">
                <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Web Role</label>
                <div>
                    <SBADropDown
                        className="w-50"
                        data={WebRoles}
                        value={SelectedWebRoles}
                        textField={"WebContactRoleName"}
                        valueField={"WebContactRoleId"}
                        onChange={Webrolechange}
                        popupSettings={{ className: "modalDD" }}
                    />
                </div>
            </div>
            <div className="ag-theme-alpine" style={{ height: "600px", width: "80%" }}>
                <AgGridReact
                    columnDefs={WebcolumnDefs}
                    rowData={WebGriddata}
                    getRowNodeId={(data) => data.id}
                    defaultColDef={{ flex: 1 }}
                />
            </div>
            <div className="mt-4">
                <button className="s-sm-btn mx-1" onClick={closeaccess}>
                    Cancel
                   </button>
                <button className="p-sm-btn mx-1" onClick={SaveAccess}>
                    Save
                  </button>
            </div>
        </div>
    </div></SBADrawer>

    }
const CopyAccessDrawer=({open,setOpen})=>
{
    const dispatch = useDispatch();
    const params = useParams();
    const [contactData, setcontactData] = useState([]);
    const [selectedcontact, setselectedcontact] = useState([]);
    const [copyportalList, setcopyportalList]= useState([]);
    const [copyGriddata,setCopyGriddata]= useState([]);
    const [copyDetailData,setcopyDetailData]= useState([]);
    const[savedata,setSavedata]=useState([paincopyAccessdata]);
    const [parentContactId,setparentcontactId]=useState();
    useEffect(() => {   
    GetAvailableInvestors("");
    dispatch(getActivityEntityType(2));
    },[copyGriddata])
    const getcopyaccessList = async (contactId) => {
        try {
            const response = await sbaAxios({ url: `${getGrantedPortalAccessAPI}${contactId}` });
          
            return response; 
        } catch (error) {
            console.error("Error fetching portal list:", error);
            return []; 
        }
    };      
    const childCopydataCheckChange=(e,props)=>
    { 
        props.node.setDataValue(props.colDef.field, e.target.checked);
        const field=props.colDef.field;
        setSavedata(prevState => {
            return prevState?.map(item => {
                 if(item.InvestorContactId === props.data.parentcontactinvestorid)
                 {  
                  
                     item.ContactTaxEntityPermissionLst =item.ContactTaxEntityPermissionLst.map(dataItem=>{
                     
                         if(dataItem.TaxEntityId === props.data.taxEntityId)
                         dataItem[field]= e.target.checked===false?0:1
                         return dataItem;
                     })
                 }
                 return item;
             });
         })
    }  
    const parentCopydataCheckChange=(e,props)=>
    { 
        props.node.setDataValue(props.colDef.field, e.target.checked);
        const field=props.colDef.field;
        setSavedata(prevState => {
            return prevState?.map(item => {
                 if(item.InvestorContactId === props.data.InvestorContactId)
                 {  
                   
                
                         item[field]= e.target.checked===false?0:1
                         return item;
                    
                 }
                 else
                 {
                    return item;
                 }
                
             });
         })
    }
    const CheckboxRenderer = (props) => {
        const checked = props.value === true;
        return (
            <div className="d-flex justify-content-start align-items-center h-100" style={{ paddingLeft: '10px' }}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => {
                        childCopydataCheckChange(e,props)
                    }}
                />
            </div>
        );
    };
    const parentCheckboxRenderer = (props) => {
    
        const checked = props.value === 1?true:false;
        return (
            <div className="d-flex justify-content-start align-items-center h-100" style={{ paddingLeft: '10px' }}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => {
                        parentCopydataCheckChange(e,props)
                    }}
                />
            </div>
        );
    };
    const columnDefss = [
        { headerName: "Investor Name", field: "InvestorName", cellRenderer: 'agGroupCellRenderer' },
        { headerName: "Client Reporting", field: "ClientReporting", editable: true, cellRenderer: parentCheckboxRenderer, width: 150 },
        { headerName: "Advisory Agreement", field: "AdvisoryAgreement", editable: true, cellRenderer: parentCheckboxRenderer, width: 150 },
        { headerName: "Billing", field: "Billing", editable: true, cellRenderer: parentCheckboxRenderer, width: 150 },
    ];
    const autoGroupColumnDef = {
        headerName: "",
        minWidth: 250,
        // cellRendererParams: {
        //     suppressCount: true,
    
        // },
    };
    const ActionsRenderer = (props) => {
        
    
        const handleDeleteClick = () => {
    
            
        }
        return (
            <div className="actions-cell">
    
                <i className="fa fa-trash" style={{ color: "red", margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick}></i>
            </div>)
    
    };
    const detailCellRendererParams = useMemo(() => ({
        detailGridOptions: {
            columnDefs: [
                { headerName: "", field: "", cellRenderer: ActionsRenderer },
                { headerName: "Account Name", field: "AccountName" },
                { headerName: "Send Statement", field: "SendStatement", cellRenderer: CheckboxRenderer},
                { headerName: "SBA Tax Reporting", field: "SbaTaxReporting", cellRenderer: CheckboxRenderer },
                { headerName: "Tax Reporting", field: "TaxReporting", cellRenderer: CheckboxRenderer },
                { headerName: "Manager Commentary", field: "ManagerCommentary", cellRenderer: CheckboxRenderer },
                { headerName: "Client Reporting", field: "ClientReporting", cellRenderer: CheckboxRenderer },
                { headerName: "Advisory Agreement", field: "AdvAgreement", cellRenderer: CheckboxRenderer },
                { headerName: "Billing", field: "Billing", cellRenderer: CheckboxRenderer },
                { headerName: "Presentation", field: "Presentation", cellRenderer: CheckboxRenderer },
                { headerName: "Manager Statements", field: "ManagerStatements", cellRenderer: CheckboxRenderer },
                { headerName: "Transactions", field: "Transactions", cellRenderer: CheckboxRenderer },
                { headerName: "Insurance Statements", field: "InsuranceStatements", cellRenderer: CheckboxRenderer },
                { headerName: "CapCall/Distribution", field: "CapCallDistribution", cellRenderer: CheckboxRenderer },
                { headerName: "Quarterly Letter", field: "QuarterlyLetter", cellRenderer: CheckboxRenderer },
                { headerName: "Insurance Docs And Reporting", field: "InsuranceDocsAndReporting", cellRenderer: CheckboxRenderer },
                { headerName: "Tax Planning", field: "TaxPlanning", cellRenderer: CheckboxRenderer },
                { headerName: "Legal Docs", field: "LegalDocs", cellRenderer: CheckboxRenderer },
                { headerName: "GenSpring Client Reporting", field: "GenSpringClientReporting", cellRenderer: CheckboxRenderer },
                { headerName: "DueDiligence Materials", field: "DueDiligenceMaterials", cellRenderer: CheckboxRenderer },
                { headerName: "Other Legal Documents(AII)", field: "OtherLegalDocuments", cellRenderer: CheckboxRenderer },
                { headerName: "Personal Documents", field: "PersonalDocuments", cellRenderer: CheckboxRenderer },
                { headerName: "Legal Documents", field: "LegalDocuments", cellRenderer: CheckboxRenderer },
                { headerName: "Other MiscDocuments", field: "OtherMiscDocuments", cellRenderer: CheckboxRenderer },
                { headerName: "Other Private", field: "OtherPrivate", cellRenderer: CheckboxRenderer },
                { headerName: "Executed DocumentsBinder1", field: "ExecutedDocumentsBinder1", cellRenderer: CheckboxRenderer },
                { headerName: "Executed DocumentsBinder2", field: "ExecutedDocumentsBinder2", cellRenderer: CheckboxRenderer },
                { headerName: "Due Diligence Memos", field: "DueDiligenceMemos", cellRenderer: CheckboxRenderer },
                { headerName: "Email Statement", field: "EmailStatement", cellRenderer: CheckboxRenderer },
                { headerName: "Manager Document", field: "ManagerDocument", cellRenderer: CheckboxRenderer },
                { headerName: "Fax Statement", field: "FaxStatement", cellRenderer: CheckboxRenderer },
                { headerName: "Consolidated Statement", field: "ConsolidatedStatement", cellRenderer: CheckboxRenderer },
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 150,
                resizable: true,
            },
        },
       

        // Locate the parent item using both ContactId and InvestorContactId
     //   const parentItem = portalList.find(item => item.ContactId === parentId && item.InvestorContactId === parentInvestorContactId);
    //    console.log("Matched parent item:", parentItem); // Debug log

       // if(parentItem && parentItem.ContactTaxEntityPermissionLst && parentItem.ContactTaxEntityPermissionLst.length > 0) {
        // Filter the permissions to match the specific InvestorContactId
       
        getDetailRowData: (params) => {
            setparentcontactId();
            const parentId = params.data.ContactId;
            const parentInvestorContactId = params.data.InvestorContactId;
            console.log("Fetching details for parent ID:", parentId, "and InvestorContactId:", parentInvestorContactId); // Debug log
            const parentItem = copyGriddata.find(item => item.ContactId === parentId && item.InvestorContactId === parentInvestorContactId);
            if (params.data.ContactTaxEntityPermissionLst.length > 0) {
                if (parentItem && parentItem.ContactTaxEntityPermissionLst && parentItem.ContactTaxEntityPermissionLst.length > 0) {
                    const filteredPermissions = parentItem.ContactTaxEntityPermissionLst.filter(permission => permission.InvestorContactId === parentInvestorContactId);
                    const formattedDatas = filteredPermissions.map(permission => ({
                        id: permission.ContactId,
                        parentcontactinvestorid:parentItem.InvestorContactId,
                        taxEntityId: permission.TaxEntityId,
                        AccountName: permission.TaxEntityName,
                        ClientReporting: permission.ClientReporting === 1,
                        SbaTaxReporting: permission.SBATaxReporting === 1,
                        TaxReporting: permission.TaxReporting === 1,
                        ManagerCommentary: permission.ManagerCommentary === 1,
                        ClientReporting: permission.ClientReporting === 1,
                        AdvAgreement: permission.AdvisoryAgreement === 1,
                        Billing: permission.Billing === 1,
                        Presentation: permission.Presentations === 1,
                        ManagerStatements: permission.ManagerStatements === 1,
                        Transactions: permission.Transactions === 1,
                        InsuranceStatements: permission.InsuranceStatements === 1,
                        CapCallDistribution: permission.CapCallDistribution === 1,
                        QuarterlyLetter: permission.QuarterlyLetter === 1,
                        InsuranceDocsAndReporting: permission.InsuranceDocsAndReporting === 1,
                        TaxPlanning: permission.TaxPlanning === 1,
                        LegalDocs: permission.LegalDocs === 1,
                        GenSpringClientReporting: permission.GenSpringClientReporting === 1,
                        DueDiligenceMaterials: permission.DueDiligenceMaterials === 1,
                        OtherLegalDocuments: permission.OtherLegalDocuments === 1,
                        PersonalDocuments: permission.PersonalDocuments === 1,
                        LegalDocuments: permission.LegalDocuments === 1,
                        OtherMiscDocuments: permission.OtherMiscDocuments === 1,
                        OtherPrivate: permission.OtherPrivate === 1,
                        ExecutedDocumentsBinder1: permission.ExecutedDocumentsBinder1 === 1,
                        ExecutedDocumentsBinder2: permission.ExecutedDocumentsBinder2 === 1,
                        DueDiligenceMemos: permission.DueDiligenceMemos === 1,
                        EmailStatement: permission.EmailStatement === 1,
                        ManagerDocument: permission.ManagerDocument === 1,
                        FaxStatement: permission.FaxStatement === 1,
                        ConsolidatedStatement: permission.ConsolidatedStatement === 1,
                    }));

                    params.successCallback(formattedDatas);
                }
            }
            else {
                params.successCallback([]);
            }
        },
    }), [copyGriddata,parentContactId]);
    const copyContactchange = async (event) => {

        if (event.value) {
            setparentcontactId();
            setselectedcontact(event.value);
            const dt = await getcopyaccessList(event.value.ContactId);
            setCopyGriddata(val => dt || []);
            const ds = dt?.map(item => {
                item.ContactId = params.ContactId
                item.ContactTaxEntityPermissionLst = item.ContactTaxEntityPermissionLst.map(dataItem => {
                    dataItem.ContactId = params.ContactId;
                    return dataItem;

                });
                return item;
            });
            setSavedata(ds);
            const detaileddata = dt.map(item => ({
                ContactTaxEntityPermissionLst: item.ContactTaxEntityPermissionLst,
            }));
            setcopyDetailData(detaileddata);
        }

     }
const GetAvailableInvestors = async (terms) => {

        const response = await sbaAxios({
            url: `${getAvailableInvestors}?contactId=${params.ContactId}&searchText=${terms}`,
            method: 'get',
        });
       
        setcontactData(response);
    }
    
const SaveCopyAccess=()=>
{
     
            sbaAxios({
                url: `${copyContactWebAccess}`,
                method: "post",
                data: savedata,
            }).then((response) => {
                if (response) {
                    SBNotify({ Msg: "Save  sucessfully" });
                    setOpen(false);
                }
            }).catch((error) => {
                SBNotify({ Msg: "some error  occured", type: "error" });
            });
      
}
   return  <SBADrawer
    open={open}
    setOpen={setOpen}
    close={false}
    title={"Copy Account Permissions "}
>
    <div className="drawer">
        <div>
            <div className="mb-4">
                <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Source Select</label>
                <div>
                       <SBAComboBox
                        className="w-50"
                        data={contactData}
                        value={selectedcontact}
                        textField={"ContactName"}
                        valueField={"ContactId"}                       
                        onChange={copyContactchange}
                        popupSettings={{ className: "modalDD" }}
                    />
                </div>

            </div>
           
            <div id="granted" className="ag-theme-alpine" style={{ height: "800px", width: "100%" }}>
                <AgGridReact
                    columnDefs={columnDefss}
                    rowData={copyGriddata}
                    masterDetail={true}
                    detailCellRendererParams={detailCellRendererParams}
                    defaultColDef={{ flex: 1 }}
                    autoGroupColumnDef={autoGroupColumnDef}
                    getRowNodeId={(data) => data.id}
                />
            </div>


            <div className="mt-4">
                <button className="s-sm-btn mx-1" onClick={() => {
                    setOpen(false);
                }}>
                    Cancel
  </button>
                <button className="p-sm-btn mx-1"  onClick={SaveCopyAccess}>
                    Save
  </button>

            </div>
        </div>
    </div>
</SBADrawer>

}
const paincopyAccessdata={
    "contactId": 0,
    "investorContactId": 0,
    "investorName": "string",
    "sendStatement": 0,
    "advisoryAgreement": 0,
    "billing": 0,
    "contactTaxEntityPermissionLst": [
      {
        "contactId": 0,
        "investorContactId": 0,
        "investorName": "string",
        "taxEntityId": 0,
        "taxEntityName": "string",
        "sendStatement": 0,
        "sbaTaxReporting": 0,
        "taxReporting": 0,
        "managerCommentary": 0,
        "financialStatements": 0,
        "advisoryAgreement": 0,
        "billing": 0,
        "presentations": 0,
        "managerStatements": 0,
        "transactions": 0,
        "insuranceStatements": 0,
        "capCallDistribution": 0,
        "quarterlyLetter": 0,
        "insuranceDocsAndReporting": 0,
        "taxPlanning": 0,
        "legalDocs": 0,
        "genSpringClientReporting": 0,
        "dueDiligenceMaterials": 0,
        "otherLegalDocuments": 0,
        "personalDocuments": 0,
        "legalDocuments": 0,
        "otherMiscDocuments": 0,
        "otherPrivate": 0,
        "executedDocumentsBinder1": 0,
        "executedDocumentsBinder2": 0,
        "dueDiligenceMemos": 0,
        "emailStatement": 0,
        "managerDocument": 0,
        "faxStatement": 0,
        "consolidatedStatement": 0
      }
    ]
  }